import { useNavigate } from "react-router-dom";
import { GRS, PSC } from "navigation/Paths";
import { Stack, UnstyledButton } from "@mantine/core";

export const InstrumentsList = () => {
  const navigate = useNavigate();
  return (
    <Stack>
      <UnstyledButton onClick={() => navigate(GRS)}>
        Global Rating Scale
      </UnstyledButton>
      <UnstyledButton onClick={() => navigate(PSC)}>
        Procedure-Specific Checklist
      </UnstyledButton>
    </Stack>
  );
};
